import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Container, Image, Table, Button, Form } from 'react-bootstrap';
import Icofont from 'react-icofont';
import HeadingValue from './common/HeadingValue';
import PageTitle from './common/PageTitle';
import { liefershops } from '../utils.js';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';


class Feedback extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            thema: 'allgemein',
            nachricht: '',
            agree: false,
        };
    }

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState({
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        const { email, thema, nachricht } = this.state;

        // Створюємо об'єкт лише з непорожніми полями
        const dataToSend = {
            nachricht,
            thema,
            ...(email && { email }) // додамо email лише якщо він не порожній
        };

        try {
            const response = await fetch(liefershops('api/v1/feedback/'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            });

            if (response.ok) {
                // alert('Форма успішно відправлена!');
                // Очищаємо форму
                this.setState({
                    email: '',
                    thema: 'allgemein',
                    nachricht: '',
                    agree: false,
                });
                this.props.history.push('/thanksforfeedback');
            } else {
                alert('Помилка при відправці.');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    render() {

        const { email, thema, nachricht, agree } = this.state;

        return (
            <>
                <Helmet>
                    <title>Geben Sie Ihr Feedback für Liefershops.de</title>
                    <meta name="description" content="Geben Sie uns Ihre Meinung zu Liefershops.de | S.Betz Company Ortolfstraße 172, 12524 Berlin, E-Mail: kontakt@lieferberlin.de" />
                    <meta name="keywords" content="Feedback, Kontakt, Essen bestellen" />
                    <meta property="og:title" content="Geben Sie Ihr Feedback für Liefershops.de S.Betz Company" />
                    <meta property="og:description" content="Geben Sie uns Ihre Meinung zu Liefershops.de | S.Betz Company Ortolfstraße 172, 12524 Berlin, E-Mail: kontakt@lieferberlin.de" />
                    <meta property="og:type" content="website" />
                    <meta name="robots" content="index, follow" />
                </Helmet>
                <PageTitle
                    title="Geben Sie uns Feedback!"
                />
                <section className="section pt-5 pb-5">
                    <Container>
                        <Row>
                            <Col md={12} className="mx-auto">
                                <div className="p-5 rounded shadow-sm mb-4 bg-white">

                                    <Row className="mt-5">
                                        <Col md={12}>
                                            <p className="mb-3">Geben Sie uns Ihre Meinung zu dieser Seite. Wenn etwas
                                                schwer zu bedienen ist oder Sie eine Idee für weitere Funktionen haben,
                                                werden wir versuchen es zu verbessern. Jede Nachricht wird persönlich
                                                von einem Mitarbeiter gelesen! </p>
                                            <Col md={8} className="card offer-card shadow-sm mb-4 p-5 mt-5">
                                                <Form className="newsletter-form mb-1" onSubmit={this.handleSubmit}>
                                                    <Form.Group>
                                                        <Form.Label><small>E-Mail Adresse </small></Form.Label>
                                                        <Form.Control className="email-input" type="text"
                                                            placeholder="Ihre E-Mail" name="email"
                                                            value={email} onChange={this.handleChange}>

                                                        </Form.Control>
                                                        <p>Diese Angabe ist freiwillig. Wenn sie dieses Feld ausfüllen,
                                                            dann werden Sie benachrichtigt, sobald wir es
                                                            durchführen.</p>
                                                    </Form.Group>

                                                    <Form.Group>
                                                        <Form.Label><small>Thema </small></Form.Label>
                                                        <Form.Control as="select" aria-label="Default select example"
                                                            name="thema" value={thema}
                                                            onChange={this.handleChange}>
                                                            {/*<option>Thema</option>*/}
                                                            <option value="allgemein">Allgemeiner Feedback</option>
                                                            <option value="verbesserung">Verbesserungsvorschlag</option>
                                                            <option value="layout">Website-Design bzw.Layout Feedback
                                                            </option>
                                                        </Form.Control>
                                                    </Form.Group>

                                                    <Form.Group className="mb-3"
                                                        controlId="exampleForm.ControlTextarea1">
                                                        <Form.Label><small>Ihre Nachricht an uns </small></Form.Label>
                                                        <Form.Control as="textarea" rows={6} cols={5} name="nachricht"
                                                            resize-none required value={nachricht}
                                                            onChange={this.handleChange}
                                                            placeholder="Ihre Nachricht" />
                                                    </Form.Group>

                                                    <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                                        <Form.Check required type="checkbox" checked={agree}
                                                            onChange={this.handleChange} name="agree"
                                                            label="ich bin mit der Datenschutzerklärung einverstanden" />
                                                    </Form.Group>

                                                    {/*<Link to="/thanksforfeedback" className="btn btn-primary btn-gradient mr-2 mb-2">Feedback senden</Link>/!*отправить *!/*/}
                                                    <Button className="btn btn-primary btn-gradient mr-2 mb-2"
                                                        type="submit">Feedback senden</Button>

                                                    <Link to="/"
                                                        className="btn btn-primary btn-gradient mb-2">Abbrechen</Link>{/*отменить */}
                                                </Form>
                                            </Col>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </>
        );
    }
}


export default withRouter(Feedback);